export const config = {
    apiUrl: 'https://api.impulseitsolution.com/api',
    baseUrl: 'api.impulseitsolution.com',
    imageUrl: 'https://api.impulseitsolution.com/storage',
    webUrl: 'https://impulseitsolution.com',
};


